import { inject, Injectable } from '@angular/core';
import Keycloak from 'keycloak-js';
import { computed, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class KeycloakService {
  private keycloak = inject(Keycloak);

  // Signal to track when roles are loaded
  private readonly rolesLoaded = signal(false);

  // Computed signal for user roles
  readonly userRoles = computed(() => {
    if (!this.keycloak.authenticated || !this.rolesLoaded()) {
      return [];
    }

    const realmRoles = this.keycloak.realmAccess?.roles || [];
    const resourceRoles = Object.values(this.keycloak.resourceAccess || {}).flatMap((resource) => resource.roles || []);

    return [...realmRoles, ...resourceRoles];
  });

  constructor() {
    // Initialize roles when service is created
    this.loadRoles();
  }

  private loadRoles(): void {
    if (this.keycloak.authenticated) {
      this.rolesLoaded.set(true);
    }
  }

  isAdmin(): boolean {
    return this.userRoles().includes('Admin');
  }

  isStandardUser(): boolean {
    return this.userRoles().includes('User');
  }

  /**
   * Check if user is authenticated
   */
  isAuthenticated(): boolean {
    return this.keycloak.authenticated || false;
  }

  /**
   * Get the current user's ID
   */
  getUserId(): string | null {
    return this.keycloak.tokenParsed?.sub || null;
  }

  login(): void {
    this.keycloak.login();
  }

  logout(): void {
    this.keycloak.logout();
  }
}
